const o = "styles-module__overviewForm___ACbFz", e = "styles-module__overviewFormTitle___nX-Qb", t = "styles-module__overviewQuestions___89AmD", r = "styles-module__uploadButton___dHpSa", s = "styles-module__overviewFormError___-GbL7", _ = "styles-module__submitButton___K7267", v = {
  overviewForm: o,
  overviewFormTitle: e,
  overviewQuestions: t,
  uploadButton: r,
  overviewFormError: s,
  submitButton: _
};
export {
  v as default,
  o as overviewForm,
  s as overviewFormError,
  e as overviewFormTitle,
  t as overviewQuestions,
  _ as submitButton,
  r as uploadButton
};
